import { inject, provideAppInitializer } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { ICON_SVGS } from './icon-svgs.generated';

/**
 * Registra el set curado de iconos Lucide (docs/brand-guidelines.md §5) como iconos SVG con
 * nombre en MatIconRegistry, para usarlos como `<mat-icon svgIcon="pencil" />` en toda la app.
 *
 * Excepción documentada a la regla "sin bypassSecurityTrust*" (implementation-plan.md §5): el
 * contenido de `ICON_SVGS` es estático, generado en build-time por scripts/generate-icons.mjs a
 * partir del paquete `lucide-static` — nunca contiene datos de usuario ni de red. Es el patrón
 * estándar de Angular Material para registrar sets de iconos locales
 * (ver https://material.angular.dev/components/icon).
 */
export function provideAppIcons() {
  return provideAppInitializer(() => {
    const registry = inject(MatIconRegistry);
    const sanitizer = inject(DomSanitizer);
    for (const [name, svg] of Object.entries(ICON_SVGS)) {
      registry.addSvgIconLiteral(name, sanitizer.bypassSecurityTrustHtml(svg));
    }
  });
}
